import './../App.css';
import {BeckyThemeProvider} from "@coolblue-development/themes";
import Header from "./Header";
import {Box} from "@coolblue-development/becky";
import styled from "@emotion/styled";
import {Paper, useMediaQuery} from "@mui/material";
import Login from "./Login";
import {getCookie} from "../utils/cookie";
import Calculator from "../components/Calculator";
import Initialize from "../components/Initialize";
import {useNavigate, useParams} from "react-router-dom";
import Footer from "./Footer";

function InitializeOverview() {
    const isMobile = useMediaQuery('(max-width:600px)');
    if(!getCookie('user_id')) {
        return <Login />
    }

  return (
    <BeckyThemeProvider>
        <Header />

        <Box p={6} component="main">
            <StyledPaper>
                <Initialize />
            </StyledPaper>
        </Box>

        {!isMobile && (
            <Footer />
        )}
    </BeckyThemeProvider>
  );
}

const StyledPaper = styled(Paper)`
  min-height: 89vh;
`;

export default InitializeOverview;
